<template>
  <Modal v-model="displayModal" :footer="false" :header="false">
    <h2>Assign a licence</h2>
    <form @submit.prevent="assignLicenceForMember" class="modal-form">
      <br />
      <button type="submit" class="btn btn-primary mr-2" data-test="assign-licence-submit">
        Submit
      </button>
      <button type="button" @click="emit('toggle-assign-licence-modal')" class="btn btn-default">
        Cancel
      </button>
    </form>
    <p v-if="licenceError" class="text-danger mt-2">Error: {{ licenceError }}</p>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from "uiv";
import { computed, ref } from "vue";
import axios, { AxiosError } from "axios";

const props = defineProps<{
  modelValue: boolean;
  memberId: string;
}>();

const emit = defineEmits(["toggle-assign-licence-modal", "update-licences"]);

const displayModal = computed(() => {
  return props.modelValue;
});

const licenceError = ref<string | null>(null);

async function assignLicenceForMember(): Promise<void> {
  licenceError.value = null;
  try {
    const response = await axios.post(`/api/admin/assignlicence/${props.memberId}`);
    if (response.status === 200) {
      emit("toggle-assign-licence-modal");
      emit("update-licences");
    }
  } catch (err) {
    const error = err as AxiosError;
    licenceError.value = error.response?.status.toString().startsWith("4")
      ? error.response?.data
      : "There was an error assigning this licence.";
  }
}
</script>

<style scoped lang="less">
.modal-form {
  margin-top: 2rem;
}

.mr-2 {
  margin-right: 2rem;
}

.mt-2 {
  margin-top: 2rem;
}

.form-control {
  max-width: 300px;
}
</style>
